import { RootStore } from '@jobnimbus/web-state';
import { ThemeProvider } from '@mui/material/styles';
import { FunctionComponent, useEffect, useState } from 'react';

import {
  AttachFileDialog,
  EngageIframe,
  FilterInbox,
  SaveOptions,
  SaveToContactModal,
  SaveToJobModal,
  SelectJobModal,
  UploadOptions,
} from './components';
import { addWindowEventListeners, subscribeToStoreChanges } from './services';

import { theme } from './root.styles';

export interface RootProps {
  rootStore: RootStore;
  engageOrigin: string;
  api1Origin: string;
}

export const Root: FunctionComponent<RootProps> = ({
  rootStore,
  engageOrigin,
  api1Origin,
}) => {
  const [jobsEnabled, setJobsEnabled] = useState(rootStore.userStore.jobsEnabled);

  useEffect(() => {
    // Set default browser tab title
    document.title = 'Engage | JobNimbus';

    const storeSubscriptions = subscribeToStoreChanges({
      rootStore,
      engageOrigin,
    });

    const jobsEnabledSubscription = rootStore.userStore.stateWithPropertyChanges.subscribe(
      (propertyChanges) => {
        if (propertyChanges?.stateChanges?.jobsEnabled !== undefined) {
          setJobsEnabled(propertyChanges.stateChanges.jobsEnabled);
        }
      }
    );

    addWindowEventListeners({ engageOrigin, rootStore });

    return () => {
      storeSubscriptions.forEach((subscription) => subscription.unsubscribe());
      jobsEnabledSubscription.unsubscribe();
    };
  }, [rootStore, engageOrigin]);

  const { accessToken } = rootStore.userStore;

  return (
    <>
      <ThemeProvider theme={theme}>
        <FilterInbox
          accessToken={accessToken}
          api1Origin={api1Origin}
          engageOrigin={engageOrigin}
        />
        <AttachFileDialog
          engageOrigin={engageOrigin}
          accessToken={accessToken}
          api1Origin={api1Origin}
        ></AttachFileDialog>
        <SaveOptions
          engageOrigin={engageOrigin}
          jobsEnabled={jobsEnabled}
          accessToken={accessToken}
          api1Origin={api1Origin}
        ></SaveOptions>
        <SaveToContactModal
          api1Origin={api1Origin}
          accessToken={accessToken}
          engageOrigin={engageOrigin}
        ></SaveToContactModal>
        <SaveToJobModal
          api1Origin={api1Origin}
          accessToken={accessToken}
          engageOrigin={engageOrigin}
        ></SaveToJobModal>
        <SelectJobModal
          engageOrigin={engageOrigin}
          accessToken={accessToken}
        ></SelectJobModal>
        <UploadOptions
          engageOrigin={engageOrigin}
          jobsEnabled={jobsEnabled}
        ></UploadOptions>
        <EngageIframe
          accessToken={rootStore.userStore.accessToken}
          engageOrigin={engageOrigin}
        ></EngageIframe>
      </ThemeProvider>
    </>
  );
};
